import { assertNever } from "../../lib/assertNever";
export type NameModel = { active: boolean; saving: boolean; draft: string };
export type NameMsg =
  | { type: "Start"; value: string }
  | { type: "Change"; value: string }
  | { type: "Commit"; value: string }
  | { type: "Close" };
export function updateName(
  model: NameModel,
  msg: NameMsg,
): readonly [NameModel, readonly never[]] {
  switch (msg.type) {
    case "Start":
      return model.saving
        ? [model, []]
        : [{ active: true, saving: false, draft: msg.value }, []];
    case "Change":
      return [{ ...model, draft: msg.value }, []];
    case "Commit":
      return [{ active: false, saving: true, draft: msg.value }, []];
    case "Close":
      return [{ active: false, saving: false, draft: "" }, []];
    default:
      return assertNever(msg);
  }
}
